import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import ActionBookingsDetailsController from 'uplisting-frontend/pods/action/bookings/details/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';
export default abstract class SidebarBookingsDetailsRoute extends ProtectedRoute {
  abstract parentRoute: string;

  @service('calendar/manager')
  calendarManager!: Services['calendar/manager'];

  @service('booking-drawer')
  bookingDrawer!: Services['booking-drawer'];

  model() {
    return this.modelFor(this.parentRoute) as ModelRegistry['booking'];
  }

  setupController(
    controller: ActionBookingsDetailsController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { booking: model });
  }

  resetController(
    controller: ActionBookingsDetailsController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (this.bookingDrawer.isOpen) {
      return;
    }

    this.calendarManager.interaction.discardMoveOf(controller.booking);

    if (!controller.booking.isDeleted && !controller.booking.isDestroyed) {
      controller.booking?.rollbackAttributes();
    }
  }
}
